<template>
  <div class="bto-sb-widget bto-sb-widget-betting-menu" ref="bettingMenu">
    <div class="bto-sb-widget-content">
      <ul>
        <Fragment v-if="resizerService.expanded">
          <li
            v-for="(l, index) in links"
            :key="index"
            :class="{ 'bto-sb-betting-menu-active': index === selectedLinkIndex }">
            <component :is="l.component" v-bind="l.props">{{ t(l.label) }}</component>
          </li>
        </Fragment>
        <li class="bto-sb-betting-menu-collapse">
          <a href="javascript:void(0);" v-on:click.prevent="resizerService.toggleLeftColumn"></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import store from '../../../store';
  import LeftcolResizerService from '../../../services/leftcol-resizer-service';
  import RouterService from '../../../services/router-service';
  import { EventBus } from '../../../services/event-bus-service';
  import { getLinkProps } from '@bto-services/quick-links';

  export default {
    name: 'BettingMenuWidget',
    data() {
      return {
        resizerService: new LeftcolResizerService(),
        selectedLinkIndex: 0
      };
    },
    props: {
      navlinks: {
        fieldType: 'link-repeater',
        label: 'Add Links',
        default: () => [
          {
            applied: true,
            editmode: false,
            label: 'Link1',
            link: '#',
          },
          {
            applied: true,
            editmode: false,
            label: 'Link2',
            link: '#',
          },
        ],
      },
    },
    computed: {
      leftColExpanded() {
        return store.state.LayoutModule.leftColExpanded;
      },
      links() {
        return this.navlinks.map(l => getLinkProps(l));
      },
    },
    mounted() {
      this.resizerService.setWindowResizeEvents();
      this.$refs.bettingMenu.parentNode.style.height = '35px';
      this.$refs.bettingMenu.parentNode.style.marginBottom = '3px';
      // If we come from layout with no left col and prev state was collapsed
      // we need to update left col
      if (this.resizerService.expanded !== this.leftColExpanded) {
        this.resizerService.expanded = this.leftColExpanded;
      }
      // @todo try to find better solution to this ugly hack.
      // @todo We must add small delay timeout here so we can be sure that slot contents had been loaded
      this.$nextTick(() => {
        setTimeout(() => {
          this.resizerService.init();
          if (!this.leftColExpanded) {
            EventBus.$emit('leftColToggle', this.leftColExpanded);
          }
        }, 30);
      });
      // EventBus.$on('btoMainNavClicked', () => {
      //   this.selectedLinkIndex = -1;
      // });
      this.checkRoute(this.$router.currentRoute);
      /**
       * Remove styles from parent node before destroy,so they aren't added to other widgets
       * need to call it from here because before destroy destroys the vue ref
       */
      const pn = this.$refs.bettingMenu.parentNode;
      this.$once('hook:beforeDestroy', () => {
        if (pn) {
          pn.style.height = null;
          pn.style.marginBottom = null;
        }
      });
    },
    beforeDestroy() {
      this.resizerService.destroy();
    },
    methods: {
      checkRoute(route) {
        const selectedIndex = this.navlinks.findIndex(link => {
          if (route.path.includes('event-view')) {
            return link.link.includes('event-view');
          }
          const base = this.$router.history.base;
          if (this.$router.mode !== 'hash') {
            return link.link.replace(base, '') === route.path;
          }
          return link.link.replace('#', '') === route.path;
        });
        this.selectedLinkIndex = selectedIndex === -1 ? 0 : selectedIndex;
      },
    },
    watch: {
      '$route': function (to, from) {
        this.checkRoute(to);
        // If we change layout we need to recalculate left widgets
        if (RouterService.getLayoutName(to) !== RouterService.getLayoutName(from)) {
          this.$nextTick(() => {
            this.resizerService.showLeftWidgets();
            EventBus.$emit('leftColToggle', this.leftColExpanded);
          });
        }
      },
    },
  };
</script>
<style>
  div.bto-sb-short-col .bto-sb-widget-content {
    display: none;
  }

  div.bto-sb-short-col div.bto-sb-widget-betting-menu .bto-sb-widget-content {
    display: block !important;
  }
</style>
